<script>
  import { flip } from "svelte/animate";
  import { fly } from "svelte/transition";
  import { myWorkouts } from "../utils/myWorkoutStore";

  let name;
  let id;

  function edit(idToEdit, newName) {
    if (id) {
      updateName(id, name);
    }
    myWorkouts.edit(idToEdit);
    name = newName;
    id = idToEdit;
  }

  function updateName(idToUpdate, newName) {
    myWorkouts.updateName(idToUpdate, newName);
    name = null;
    id = null;
  }
</script>

<div class="p-2">
  {#each $myWorkouts as workout (workout.id)}
    <div
      class="flex mb-2"
      animate:flip={{ duration: 200 }}
      transition:fly|local={{ x: 20, duration: 200 }}
    >
      <div
        class="flex-1 p-2 bg-gray-700 rounded-2xl opacity-90 shadow-whitesm hover:scale-y-105 transform transition duration-200 ease-in-out"
      >
        {#if !workout.isEdit}
          <a class="text-gray-100" href={workout.url}>{workout.name}</a>
        {:else}
          <input
            aria-label="Workout name"
            on:keypress={(e) => {
              if (e.key === "Enter") updateName(workout.id, name);
            }}
            bind:value={name}
            class="focus:ring-4 text-gray-100 text-sm ring-gray-500 focus:outline-none ring-opacity-30 font-semibold p-1 bg-gray-600 border-0 rounded-xl w-full"
            placeholder="name e.g &quot;Tabata&quot;"
          />
        {/if}
        <div class="flex justify-between">
          <h3 class="uppercase text-xxs font-semibold text-gray-400">
            {workout.type}
          </h3>
          <h3 class="uppercase text-xxs font-semibold text-gray-400">
            {new Date(workout.timestamp).toLocaleDateString()}
          </h3>
        </div>
      </div>
      <div class="flex flex-col justify-center pl-1">
        {#if !workout.isEdit}
          <button
            aria-label="Remove workout"
            on:click={() => myWorkouts.remove(workout.id)}
            class="bg-gray-700 text-gray-100 p-1 rounded-md mb-1 cursor-pointer select-none focus:outline-none transform hover:scale-125 focus:scale-125 transition duration-200 ease-in-out focus:bg-gray-300 focus:bg-opacity-30"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-3 w-3"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
          <button
            aria-label="Edit workout"
            on:click={edit(workout.id, workout.name)}
            class="bg-gray-700 text-gray-100 p-1 rounded-md cursor-pointer select-none focus:outline-none transform hover:scale-125 focus:scale-125 transition duration-200 ease-in-out focus:bg-gray-300 focus:bg-opacity-30"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-3 w-3"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                d="m16 2.012 3 3L16.713 7.3l-3-3zM4 14v3h3l8.299-8.287-3-3zm0 6h16v2H4z"
              />
            </svg>
          </button>
        {:else}
          <button
            aria-label="Udapte name"
            on:click={updateName(workout.id, name)}
            class="bg-gray-700 text-gray-100 p-1 rounded-md cursor-pointer select-none focus:outline-none transform hover:scale-125 focus:scale-125 transition duration-200 ease-in-out focus:bg-gray-300 focus:bg-opacity-30"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-3 w-3"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"
              />
            </svg>
          </button>
        {/if}
      </div>
    </div>
  {/each}
</div>
